import groupBy from 'lodash/groupBy';
import uniq from 'lodash/uniq';

import { EventModelPosition } from '../constants';
import { formatModelSizes } from './format-model-sizes';

export function getModelRequest(models) {
  const groupedModels = groupBy(models, 'modelId');

  return Object.keys(groupedModels).map((modelId) => {
    return {
      modelId,
      sizes: formatModelSizes(
        groupedModels[modelId].map((item) => ({
          sizeId: item.sizeId,
          quantity: item.quantity,
        }))
      ),
      sides: uniq(
        groupedModels[modelId]
          .map((item) =>
            item.position === EventModelPosition.Both
              ? [EventModelPosition.Front, EventModelPosition.Back]
              : item.position
          )
          .flat()
      ),
    };
  });
}
